import { useMutation } from "@tanstack/react-query";
import {
  type Region,
  type SignInResult,
  putAuthContextRegion,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

type Props = {
  onSuccess?: (result: SignInResult) => void;
  onError?: () => void;
};

/**
 * Sets the market region of the active context (one-time, immutable). Returns a fresh SignInResult
 * whose token carries the region claim. The caller persists the token (setToken) and refreshes
 * user-info so the region gate clears.
 */
export const useSetRegionMutation = ({ onSuccess, onError }: Props = {}) =>
  useMutation({
    mutationFn: processResponseWithApiProblemDetails((region: Region) =>
      putAuthContextRegion({ region }),
    ),
    onSuccess,
    onError,
  });
